module.exports = "<!--The content below is only a placeholder and can be replaced.-->\r\n<nav class=\"navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0\">\r\n  <div class=\"col-3 col-md-2 mr-0\"><a class=\"navbar-brand ml-0 ml-sm-4\" href=\"#\">enji</a></div>\r\n</nav>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout-not-logged-in/layout-not-logged-in.component.html
// module id = ./src/app/layout-not-logged-in/layout-not-logged-in.component.html
// module chunks = main